<template>
  <thead>
    <tr class="d-flex" ref="header">
      <slot name="table-header"></slot>
    
      <th v-for="(item, i) in sizedColumns" :key="item.column"
        class="py-1 px-2 table-cell "
        :style="item.style"
        :class="{
          'drag-handle': enableSortable && (!dragDisabledOnColumns || !dragDisabledOnColumns.includes(variables[i])),
          'last-header-cell': i === sizedColumns.length - 1
        }"

        :data-column="item.column"
        :data-columnvar="variables[i]"
      >
        <span @click="setSort(i)">
          <span v-html="item.column"></span>

          <SortingOptions v-if="enableSortBySpecificColumn"
            :active-sort="variables[i] === sort ? order : null"
          />
        </span>
        
        <div v-if="enableColumnResize"
          class="bordered ignore-element"

          @pointerdown="evt => pointerDown(evt, i, variables[i])"
        ></div>
      </th>
    </tr>
  </thead>
</template>

<script>

import SortingOptions from "./SortingOptions.vue"

import resizeMixin from "./resize-mixin"
import sortableMixin from "./sortable-mixin"

export default {
  mixins: [
    resizeMixin,
    sortableMixin,
  ],
  components: {
    SortingOptions,
  },
  props: {
    columns: Array, 
    dragDisabledOnColumns: Array,
    variables: Array, 
    sort: String,
    order: String,
    enableSortBySpecificColumn: Boolean,
  },
  methods: {
    setSort(index) {
      const newSort = this.variables[index]
      const order = this.order
      
      this.$emit("set-sort", newSort)
      this.$emit("set-order", (
        this.sort !== newSort ? "asc" : (order === "asc" ? "desc" : "asc")
      ))
    },
  },
}

</script>

<style scoped>

tr + tr {
  border-top: 1px solid hsla(0,0%,78.4%,.4);
}

tr {
  border-bottom: 1px solid hsla(0,0%,78.4%,.4);
}


th, tr {
  flex-basis: 100%;
}

th {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  min-width: 75px;
  font-size: 14px;
  padding: 10px 0 !important;
  padding-left: 12px !important;
  border-bottom: 1px solid #EFEFF0;
}

.last-header-cell {
  min-width: 175px;
}

th + th {
  border-left: 1px solid #EFEFF0;
}

thead th + th {
  border-left: 1px solid #dee2e6;
}



.bordered {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: -1px;
  height: 100%;
  width: 5px;
  z-index: 10;
  cursor: col-resize;
  background-color: rgba(0, 0, 0, 0.099);
  opacity: 0;
  transform: translateX(0px) scaleY(1);
  transition-duration: .075s;
}

.bordered:hover {
  opacity: 1;
  width: 10px;
  transform: translateX(3px) scaleY(1.3);
}

</style>
